"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 5.76a.5.5 0 0 1 .461.695l-3.245 7.644a.501.501 0 0 1-.461.305H.5a.5.5 0 0 1-.417-.224.49.49 0 0 1-.074-.276H0V3.22c0-.896.729-1.625 1.624-1.625h3.557L6.27 3.399h5.366c.729 0 1.321.592 1.321 1.32v.538h-1V4.72a.321.321 0 0 0-.321-.321H5.705L4.616 2.596H1.624A.626.626 0 0 0 1 3.22v8.225l2.284-5.381a.501.501 0 0 1 .461-.305H15.5ZM1.256 13.404h10.668l2.821-6.644H4.076l-2.82 6.644Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M23.438 8.784a.563.563 0 0 1 .518.782l-4.949 11.657a.563.563 0 0 1-.517.343H.563a.562.562 0 0 1-.47-.252.548.548 0 0 1-.083-.31H0V4.71a2.28 2.28 0 0 1 2.277-2.277h5.31l1.661 2.75h8.298c1 0 1.814.813 1.814 1.813v.82h-1.125v-.82a.69.69 0 0 0-.689-.688H8.614l-1.662-2.75H2.277c-.635 0-1.152.517-1.152 1.152v13.527l3.868-9.112a.564.564 0 0 1 .518-.342h17.927ZM1.413 20.44h16.704l4.47-10.532H5.884L1.413 20.44Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M31.25 11.711a.75.75 0 0 1 .691 1.043l-6.598 15.543a.751.751 0 0 1-.69.457H.75a.75.75 0 0 1-.625-.336.731.731 0 0 1-.111-.414H0V6.281a3.04 3.04 0 0 1 3.036-3.036h7.081l2.214 3.666h11.064a2.421 2.421 0 0 1 2.418 2.418v1.092h-1.5V9.33a.92.92 0 0 0-.918-.918h-11.91L9.27 4.745H3.036c-.847 0-1.536.69-1.536 1.536v18.036l5.157-12.149a.751.751 0 0 1 .691-.457H31.25ZM1.884 27.254h22.272l5.961-14.043H7.844l-5.96 14.043Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M47.063 17.712a.936.936 0 0 1 .862 1.303L37.949 42.52a.937.937 0 0 1-.864.572H.938a.938.938 0 0 1-.782-.42.933.933 0 0 1-.148-.518H0V9.304a4.4 4.4 0 0 1 4.395-4.396h10.598l3.347 5.544h16.843a3.464 3.464 0 0 1 3.46 3.46v1.65h-1.875v-1.65c0-.874-.711-1.585-1.585-1.585h-17.9l-3.35-5.544H4.396c-1.39 0-2.52 1.13-2.52 2.52v28.245l8.178-19.266a.936.936 0 0 1 .862-.57h36.148ZM2.355 41.217h34.11l9.18-21.63h-34.11l-9.18 21.63Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M62.75 23.616a1.249 1.249 0 0 1 1.15 1.738l-13.302 31.34a1.25 1.25 0 0 1-1.151.762H1.251c-.42 0-.811-.21-1.043-.56a1.244 1.244 0 0 1-.198-.69H0V12.405a5.867 5.867 0 0 1 5.86-5.86h14.13l4.464 7.392h22.457a4.62 4.62 0 0 1 4.613 4.614v2.2h-2.5v-2.2a2.116 2.116 0 0 0-2.113-2.114H23.043l-4.465-7.392H5.86a3.363 3.363 0 0 0-3.36 3.36v37.659l10.904-25.687a1.248 1.248 0 0 1 1.15-.761H62.75ZM3.14 54.956h45.48l12.241-28.84h-45.48L3.14 54.956Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFolder = function IconFolder(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Folder' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Folder"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFolder.sizes = [16, 24, 32, 48, 64];
IconFolder.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFolder;
exports.default = _default;